import styled from 'styled-components'
import Confetti from 'react-confetti'
import { Colors } from 'src/resources/colors'
import { Spacing } from 'src/resources/layout'

const OverlayContainer = styled.div`
  background: transparent;
  width: 633px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: ${Spacing.basePadding7x};
`
const ConfettiZIndex = styled.div`
  z-index: -1;
`

export function Overlay({
  children,
  showConfetti
}: {
  children: JSX.Element
  showConfetti?: boolean
}) {
  return (
    <OverlayContainer>
      {showConfetti && (
        <ConfettiZIndex>
          <Confetti
            colors={[
              Colors.brandPrimary,
              Colors.brandPrimaryMidnight,
              Colors.brandSecondary,
              Colors.brandAccent,
              Colors.border
            ]}
            tweenDuration={400}
          />
        </ConfettiZIndex>
      )}
      <div>{children}</div>
    </OverlayContainer>
  )
}
